import { Component, ChangeDetectionStrategy, input, model, computed } from '@angular/core';
import { CartItem, CartItemOptionItems, Category } from '@pedix-workspace/utils';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';

import { TranslocoDirective } from '@ngneat/transloco';
import { ApiV1_Product } from '@pedix-workspace/api-v1';
import { getCartItemSubtotal } from '@pedix-workspace/orders';
import { CounterComponent } from '../counter/counter.component';
import { ProductPriceComponent } from '../product-price/product-price.component';

@Component({
    selector: 'pxw-product-quantity-selector',
    templateUrl: './product-quantity-selector.component.html',
    styleUrls: ['./product-quantity-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, ButtonComponent, CounterComponent, ProductPriceComponent]
})
export class ProductQuantitySelectorComponent {
  category = input.required<Pick<Category, 'availability'>>();
  product = input.required<ApiV1_Product>();
  buttonText = input.required<string>();
  formId = input.required<string>();

  selectedPresentationOption = input.required<CartItemOptionItems>();
  selectedOptions = input.required<CartItemOptionItems[]>();

  maxQuantity = input<number>(0);
  hasStockIssues = input<boolean>(false);
  disabled = input<boolean>(false);

  productQuantity = model<number>(0);

  displayItemQuantities = computed(() => {
    const presentations = this.product().presentations;

    if (presentations) {
      return presentations.displayItemQuantities ? false : true;
    }
    return true;
  });
  cartItemSubtotal = computed(() => {
    return getCartItemSubtotal(
      {
        product: this.product(),
        qty: this.productQuantity(),
        selectedPresentation: this.selectedPresentationOption(),
        selectedOptions: this.selectedOptions(),
      },
      { usePriceDiscount: false },
    );
  });
  cartItemSubtotalWithDiscount = computed(() => {
    return getCartItemSubtotal(
      {
        product: this.product(),
        qty: this.productQuantity(),
        selectedPresentation: this.selectedPresentationOption(),
        selectedOptions: this.selectedOptions(),
      },
      { usePriceDiscount: true },
    );
  });
}
